import type { Dispatch, UnknownAction } from '@reduxjs/toolkit'

import { feedbackCleared, FEEDBACK_SCOPES } from '../../../shared/model/feedbackSlice'
import { ridKey } from '../../../shared/model/keys'
import { catalogPageChanged, checkDeviceChanged, checkGoodToggled } from './catalogSlice'
import {
  catalogRefreshRequested,
  catalogReloadRequested,
  devicesRefreshRequested,
  fiscalCheckRequested,
} from './commands'
import type { CatalogActions, CatalogRidIntent, CatalogVm } from './types'

export function createCatalogActions(
  vm: CatalogVm,
  intent: CatalogRidIntent,
  dispatch: Dispatch<UnknownAction>,
  switchSource: () => void,
  openGood?: (goodId: string) => void,
): CatalogActions {
  const { resourceId } = vm
  return {
    reload: () => dispatch(catalogReloadRequested({ resourceId })),
    setPage: (page) =>
      dispatch(catalogPageChanged({ resourceId, page: Math.min(Math.max(page, 0), vm.pageCount - 1) })),
    refreshCatalog: () => {
      if (vm.busy === null) dispatch(catalogRefreshRequested({ resourceId }))
    },
    refreshDevices: () => {
      if (vm.busy === null) dispatch(devicesRefreshRequested({ resourceId }))
    },
    toggleGood: (goodId) => dispatch(checkGoodToggled({ resourceId, goodId })),
    setCheckDevice: (deviceId) => dispatch(checkDeviceChanged({ resourceId, deviceId })),
    runCheck: () => {
      if (!vm.check.canRun || intent.checkDeviceId === null) return
      dispatch(fiscalCheckRequested({ resourceId, deviceId: intent.checkDeviceId, goodIds: intent.checkGoodIds }))
    },
    dismissFeedback: () => dispatch(feedbackCleared({ key: ridKey(resourceId, FEEDBACK_SCOPES.catalog) })),
    switchSource,
    ...(openGood === undefined ? {} : { openGood }),
  }
}
